export function isMobile() {
  if (window.innerWidth < 992) {
    return true;
  } else {
    return false;
  }
}